const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/**
 * When the API sends a calendar date only (YYYY-MM-DD), show a claim countdown
 * instead of the raw date in the Deadline stat.
 */
export function formatDaysLeftToClaimLabel(isoDate: string): string | null {
  const t = isoDate.trim();
  if (!ISO_DATE.test(t)) {
    return null;
  }
  const [y, m, d] = t.split('-').map(Number);
  const deadline = new Date(y, m - 1, d);
  if (
    deadline.getFullYear() !== y ||
    deadline.getMonth() !== m - 1 ||
    deadline.getDate() !== d
  ) {
    return null;
  }
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  deadline.setHours(0, 0, 0, 0);
  const diffDays = Math.round(
    (deadline.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)
  );
  if (diffDays < 0) {
    return 'Deadline passed';
  }
  if (diffDays === 0) {
    return 'Last day to claim';
  }
  if (diffDays === 1) {
    return '1 Day Left to Claim';
  }
  return `${diffDays} Days Left to Claim`;
}

export function resolveDeadlineStatLine(
  deadlineAbsolute?: string,
  deadlineRelative?: string
): string {
  const rel = deadlineRelative?.trim() || '';
  if (rel) {
    return rel;
  }
  const abs = deadlineAbsolute?.trim() || '';
  const fromIso = formatDaysLeftToClaimLabel(abs);
  if (fromIso) {
    return fromIso;
  }
  return abs;
}
